<script lang="ts">
  export let title: string
  export let from: string
  export let price: string
  export let content: string[] = []
  export let image: string
</script>

<div class="flex flex-col h-full items-start  p-4">
  <h2 class="text-3xl text-black">{title}</h2>
  <p class="text-lg mb-1">
    {from} <span class="text-3xl font-semibold text-cs-orange">{price}</span>
  </p>
  <div class="flex-grow overflow-y-auto">
    <ul class="text-left">
      {#each content as contentItem}
        <li class="flex items-start ">
          <span class='text-cs-orange font-bold mr-2'> ✓ </span><span class="text-sm">{contentItem}</span>
        </li>
      {/each}
    </ul>
  </div>
  <div class="mt-auto flex justify-center">
    <img src={image} alt={title} class="max-w-full h-auto" />
  </div>
</div>
